import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";
import { NavLink, withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import {
  Typography,
  Collapse,
  CircularProgress,
  withStyles,
  Tooltip,
} from "@material-ui/core";
import {
  Folder,
  FolderOpen,
  KeyboardArrowUp,
  KeyboardArrowDown,
} from "@material-ui/icons";
import { CompositionStore } from "modules/composition/CompositionStore";
import Task from "modules/composition/components/layouts/Task";

const styles = (theme) => ({
  container: {
    height: "100%",
    overflowX: "hidden" as any,
    backgroundColor: "#fff",
    boxShadow: "0px 3px 6px 0px #CFCFCF",
    padding: "15px 0px",
  },
  title: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 500,
    color: "#212121",
    marginLeft: "25px",
  },
  subtitle: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 700,
    color: "#212121",
    textTransform: "uppercase" as any,
  },
  level: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "#212121",
    fontWeight: 400,
    alignItems: "center",
    minHeight: "34px",
    paddingTop: "6px",
    paddingBottom: "6px",
    display: "flex",
    textDecoration: "none",
    transition: "all 0.3s ease-in",
    "&:hover": {
      backgroundColor: "#f2f2f2",
    },
  },
  mlgdqeqcm: {
    display: "block",
    whiteSpace: "nowrap" as any,
    overflow: "hidden",
    textOverflow: "ellipsis !important",
    width: "200px",
  },
  toggle: {
    height: "34px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "25px",
    marginTop: "24px",
    cursor: "pointer",
  },
  keyboardArrow: {
    fontSize: "18px",
  },
  folder: {
    fontSize: "18px",
  },
  activeLink: {
    backgroundColor: "#697513",
    color: "#fff",
  },
});

type IProps = {
  classes: any;
};

@observer
class SideMenu extends React.Component<IProps & RouteComponentProps<IProps>> {
  state = {
    loaded: false,
    path: new Array(),
    pathString: "",
    toggleGroups: true,
    toggleGroups_: false,
  };

  constructor(props) {
    super(props);
    if (location.pathname !== this.state.pathString) {
      this.state.path = decodeURI(location.pathname).split("/");
      this.state.path.splice(0, 4);
    }
  }

  componentDidMount() {
    this.getBenchCompositionLevels();
    this.getResources();
    CompositionStore.setTooltipStyle();
  }
  getBenchCompositionLevels = async () => {
    await CompositionStore.getRootGroups(CompositionStore.benchComposition.id);
    this.setState({ loaded: true });
  };
  getResources = async () => {
    await CompositionStore.getResources(CompositionStore.benchComposition.id);
    this.setState({ loaded: true });
  };

  componentWillReceiveProps(nextProps) {
    if (location.pathname !== this.state.pathString) {
      let pathString = location.pathname;
      let path = decodeURI(location.pathname).split("/");
      path.splice(0, 4);
      this.setState({ pathString, path });
    }
  }

  getGroupsByParent = async (parent) => {
    parent.data.sublevel = [];
    await CompositionStore.getGroupsByParent(parent.id, parent.data.sublevel);
    parent.data.sublevel = [...parent.data.sublevel];
  };

  handleToggleResources = () =>
    this.setState((prevState: any) => ({
      toggleGroups: !prevState.toggleGroups,
    }));
  handleToggleResources_ = () =>
    this.setState((prevState: any) => ({
      toggleGroups_: !prevState.toggleGroups_,
    }));

  handleNavClick = (e, to) => {
    if (location.pathname === to) {
      e.preventDefault();
    }
  };

  renderLevel = (levels, index) => {
    const { classes } = this.props;
    let path =
        this.state.path.length === 0
          ? [CompositionStore.benchComposition.id]
          : [CompositionStore.benchComposition.id, ...this.state.path].slice(
              0,
              index + 1
            ),
      stringPath = path.join("/"),
      paddingLeft = `${25 * (index + 1)}px`,
      alreadyFound = false;
    return levels.map((lvl) => {
      let open = false,
        Icon = Folder,
        sublevel,
        task;
      if (!alreadyFound) {
        alreadyFound = open = lvl.id === this.state.path[index];
        if (open) {
          Icon = FolderOpen;
          if (lvl.data.sublevel)
            sublevel = this.renderLevel(lvl.data.sublevel, index + 1);
          else {
            sublevel = (
              <span
                className={classes.level}
                style={{ paddingLeft: `${25 * (index + 2)}px` }}
              >
                <CircularProgress size={15} />
              </span>
            );
            this.getGroupsByParent(lvl);
          }
          if (index + 1 === this.state.path.length)
            CompositionStore.setGroup(lvl);
          else {
            let splitted = this.state.path[index + 1].split("~");
            if (splitted[0] === "task" && lvl.data.tasks.includes(splitted[1]))
              task = (
                <Task
                  id={splitted[1]}
                  path={this.state.path}
                  index={index + 1}
                />
              );
          }
        }
      }
      return (
        <React.Fragment>
          <NavLink
            exact={true}
            onClick={(e) => {
              this.handleNavClick(
                e,
                `/menu/rateLibraries/${stringPath}/${lvl.id}`
              );
              CompositionStore.loading = false;
            }}
            className={classes.level}
            style={{ paddingLeft }}
            activeClassName={classes.activeLink}
            to={`/menu/rateLibraries/${stringPath}/${lvl.id}`}
          >
            <span style={{ marginRight: "10px" }}>
              <Icon className={classes.folder} />
            </span>

            <div className={classes.mlgdqeqcm}>
              {lvl.data.description.trim().length > 30 ? (
                <Tooltip
                  title={
                    lvl.data.description.charAt(0).toUpperCase() +
                    lvl.data.description.slice(1)
                  }
                >
                  <div>
                    {lvl.data.description.charAt(0).toUpperCase() +
                      lvl.data.description.slice(1)}
                  </div>
                </Tooltip>
              ) : (
                <div>
                  {" "}
                  {lvl.data.description.charAt(0).toUpperCase() +
                    lvl.data.description.slice(1)}
                </div>
              )}
            </div>
          </NavLink>

          {sublevel}
          {task}
        </React.Fragment>
      );
    });
  };

  render() {
    const { classes } = this.props,
      { loaded, toggleGroups, toggleGroups_ } = this.state,
      { groups } = CompositionStore;
    let path =
        this.state.path.length === 0
          ? [CompositionStore.benchComposition.id]
          : [CompositionStore.benchComposition.id, ...this.state.path].slice(
              0,
              1
            ),
      stringPath = path.join("/"),
      paddingLeft = `${25 * 1}px`,
      alreadyFound = false;
    return (
      loaded && (
        <div className={classes.container} id="sideMenuBox">
          <Typography className={classes.title}>
            {i18n.rateLibraries.browser}
          </Typography>
          <div className={classes.toggle} onClick={this.handleToggleResources}>
            <span style={{ marginRight: "10px" }}>
              {toggleGroups ? (
                <KeyboardArrowDown className={classes.keyboardArrow} />
              ) : (
                <KeyboardArrowUp className={classes.keyboardArrow} />
              )}
            </span>
            <Typography className={classes.subtitle}>
              {i18n.rateLibraries.resources}
            </Typography>
          </div>
          <Collapse
            in={toggleGroups}
            timeout="auto"
            className={classes.collapse}
            unmountOnExit
          >
            {this.renderLevel(groups, 0)}
          </Collapse>
          <div className={classes.item}>
            <Typography className={classes.subtitle} />
          </div>

          <div className={classes.toggle} onClick={this.handleToggleResources_}>
            <span style={{ marginRight: "10px" }}>
              {toggleGroups_ ? (
                <KeyboardArrowDown className={classes.keyboardArrow} />
              ) : (
                <KeyboardArrowUp className={classes.keyboardArrow} />
              )}
            </span>
            <Typography className={classes.subtitle}>
              Lista de Insumos
            </Typography>
          </div>
          <Collapse
            in={toggleGroups_}
            timeout="auto"
            className={classes.collapse}
            unmountOnExit
          >
            {/*  */}
            <React.Fragment>
              <NavLink
                exact={true}
                onClick={(e) => {
                  this.handleNavClick(
                    e,
                    `/menu/rateLibraries/${stringPath}/resources`
                  );
                  CompositionStore.loading = false;
                }}
                className={classes.level}
                style={{ paddingLeft }}
                activeClassName={classes.activeLink}
                to={`/menu/rateLibraries/${stringPath}/resources`}
              >
                <span style={{ marginRight: "10px" }}>
                  <Folder className={classes.folder} />
                </span>

                <div className={classes.mlgdqeqcm}>
                  {CompositionStore.resource.length > 0 ? (
                    <Tooltip title="Insumos">
                      <div>Insumos</div>
                    </Tooltip>
                  ) : (
                    <div>Insumos</div>
                  )}
                </div>
              </NavLink>
            </React.Fragment>
            {/*  */}
          </Collapse>
        </div>
      )
    );
  }
}

export default withStyles(styles)(withRouter(SideMenu));



// WEBPACK FOOTER //
// ./src/modules/composition/components/layouts/SideMenu.tsx